const caseStudyStats = document.querySelector(".case-study-stats");
const caseStudyStatsNumbers = Array.from(
  document.querySelectorAll(".case-study-stats p")
);

/**
 * @description - Function checks if element is in the viewport and adds appropriate class to it.
 */
const showStatsWhenInViewport = debounce(() => {
  if (caseStudyStats && isInViewport(caseStudyStats)) {
    if (!caseStudyStats.classList.contains("in-viewport")) {
      setTimeout(function() {
        caseStudyStatsNumbers.forEach(item => {
          if (!caseStudyStats.classList.contains("in-viewport")) {
            const startNumber =
              parseInt(item.innerHTML) < 1000
                ? 0
                : parseInt(item.innerHTML) - 700;
            const endNumber = parseInt(item.innerHTML);
            const duration = 3;
            const numAnim = new CountUp(
              item,
              startNumber,
              endNumber,
              0,
              duration
            ); //target // start Value // end Value // decimal Value // duration

            if (!numAnim.error) {
              numAnim.start();
            } else {
              console.error(numAnim.error);
            }
          }
        });
        caseStudyStats.classList.add("in-viewport");
      }, 1000);
    }
  }
}, 30);

/**
 * Initialize functions on start and on scroll
 */
showStatsWhenInViewport();

window.addEventListener("scroll", showStatsWhenInViewport);
